var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelecticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.5,
    viewBox: "0 0 17.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fcfcfc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.375,12.125a8.75,8.75,0,1,0,8.75-8.75A8.749,8.749,0,0,0,3.375,12.125ZM15.537,10.3a.815.815,0,0,1,1.148,0,.8.8,0,0,1,.236.572.816.816,0,0,1-.24.576L12.714,15.4a.811.811,0,0,1-1.119-.025L7.569,11.364a.812.812,0,1,1,1.148-1.148l3.412,3.445Z",
    transform: "translate(-3.375 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelecticon);
export default __webpack_public_path__ + "static/media/select icon.2e9fc4cc3a701ec3cc59be5aa8c60087.svg";
export { ForwardRef as ReactComponent };